export function createUrlFile(fileName, url) {
    return new File(["[InternetShortcut]\r\nURL=".concat(url)], "".concat(fileName, ".url"), {
        type: 'text/plain',
    });
}
//# sourceMappingURL=createUrlFile.js.map